/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {reportAppMessageDelivered} from '../api'

export const useMutationReportAppMessageDelivered = createReactQueryMutationHook('reportAppMessageDelivered', reportAppMessageDelivered)
